module.exports = __webpack_public_path__ + "img/art-18.5785c6af.png";